import { useEffect, useState, type ReactNode } from "react";
import { useNotice, type Notice } from "../../client/index.ts";
import { visuallyHidden } from "../../design/classes.ts";
import { Action } from "../../design/primitives/Action.tsx";
import { Toast } from "../../design/primitives/Toast.tsx";
import { shortcut } from "../navigation/Link.tsx";
import { shellCopy } from "../copy.ts";
import { errorWords } from "../errors/words.ts";
import styles from "./Toaster.module.css";
import { designCopy } from "../../design/copy.ts";
const shown = { plain: 5200, withAction: 7000 };
export function Toaster() {
  const { notice, dismiss } = useNotice();
  const [said, setSaid] = useState("");
  useEffect(() => {
    if (!notice || notice.kind === "segurando") return;
    const acted = (notice.kind === "falhou" && notice.retry !== undefined) || (notice.kind === "registrada" && notice.open !== undefined);
    const timer = setTimeout(() => dismiss(notice.id), acted ? shown.withAction : shown.plain);
    setSaid(notice.kind === "falhou" ? errorWords(notice.error) : "");
    return () => clearTimeout(timer);
  }, [notice, dismiss]);
  return (
    <>
      <div className={styles.toaster}>{notice ? <Toast key={notice.id} {...toastOf(notice, dismiss)} /> : null}</div>
      <p className={visuallyHidden} aria-live="assertive">
        {said}
      </p>
    </>
  );
}

function toastOf(notice: Notice, dismiss: (id: number) => void): { message: string; action?: ReactNode } {
  if (notice.kind === "conectado") return { message: shellCopy.conexao.conectado };
  if (notice.kind === "segurando") {
    return { message: notice.text, action: <Action row onClick={notice.undo} {...shortcut("u")}>{designCopy.desfazer}</Action> };
  }
  if (notice.kind === "registrada") {
    const open = notice.open;
    const action = open === undefined ? undefined : <Action row href={open.href} onClick={() => dismiss(notice.id)}>{open.label}</Action>;
    return { message: notice.text ?? shellCopy.registrado, ...(action === undefined ? {} : { action }) };
  }
  const retry = notice.retry;
  if (!retry) return { message: errorWords(notice.error) };
  const again = () => {
    dismiss(notice.id);
    retry();
  };
  return { message: errorWords(notice.error), action: <Action row onClick={again}>{designCopy.tentarDeNovo}</Action> };
}
